export default __webpack_public_path__ + "f28080b2e00befedb859012126ede7d1.png";